import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, browserSessionPersistence, browserLocalPersistence, setPersistence } from "firebase/auth";

// --- Configuración Web de tu Proyecto de Firebase ---
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// 🔐 MULTI-SESIÓN: Detectar si es una sesión aislada (temporal)
export const isIsolatedSession = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('isolated') === 'true' || sessionStorage.getItem('isolatedSession') === 'true';
};

// Generar un ID único para esta pestaña (sesiones aisladas)
const getSessionId = () => {
  if (!isIsolatedSession()) return 'main';
  
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = `isolated_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('sessionId', sessionId);
    sessionStorage.setItem('isolatedSession', 'true');
  }
  return sessionId;
};

const sessionId = getSessionId();

// Inicializar app con nombre único para sesiones aisladas
let app;
if (sessionId === 'main') {
  // Sesión principal: usar app por defecto
  const existingApps = getApps();
  app = existingApps.length > 0 ? existingApps[0] : initializeApp(firebaseConfig);
} else {
  // Sesión aislada: crear app con nombre único
  const existingApps = getApps();
  const existingApp = existingApps.find(a => a.name === sessionId);
  if (existingApp) {
    app = existingApp;
  } else {
    app = initializeApp(firebaseConfig, sessionId);
  }
}

// Exporta Firestore
export const db = getFirestore(app);

// Inicializar Auth
const auth = getAuth(app);

// Configurar persistencia según tipo de sesión
const setupPersistence = async () => {
  try {
    if (isIsolatedSession()) {
      // Sesión aislada: usar sessionStorage (no recuerda al cerrar pestaña)
      await setPersistence(auth, browserSessionPersistence);
      console.log(`🔐 Sesión aislada [${sessionId}] - No recordará credenciales`);
    } else {
      // Sesión principal: usar localStorage (recuerda credenciales)
      await setPersistence(auth, browserLocalPersistence);
      console.log('🔐 Sesión principal - Recordará credenciales');
    }
  } catch (error) {
    console.error('Error configurando persistencia:', error);
  }
};

// Ejecutar configuración de persistencia
setupPersistence();

export { auth };

// 🔐 Función para abrir nueva sesión aislada
export const openIsolatedSession = () => {
  const baseUrl = window.location.origin;
  const isolatedUrl = `${baseUrl}/login?isolated=true`;
  window.open(isolatedUrl, '_blank');
};
